import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = {
  class: "xcell xname",
  name: "left"
}
const _hoisted_4 = {
  key: 0,
  class: "xusericon",
  "data-size": "small"
}
const _hoisted_5 = { class: "xusericon-picture" }
const _hoisted_6 = { class: "xpage-openapps-box-name" }
const _hoisted_7 = { class: "name-container" }
const _hoisted_8 = ["title", "innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "xdetails"
}
const _hoisted_10 = { class: "xdetails-group" }
const _hoisted_11 = { class: "subtitle xsmall-text" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "xcell xsearchtext"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 0,
  class: "xcoapplicant-container"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "xdetails"
}
const _hoisted_20 = { class: "xdetails-group" }
const _hoisted_21 = { class: "subtitle xsmall-text" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "xdetails-group" }
const _hoisted_25 = { class: "xpill light" }
const _hoisted_26 = { class: "right" }
const _hoisted_27 = {
  key: 0,
  class: "xcell xdetails-group",
  name: "status"
}
const _hoisted_28 = { class: "xpill light" }

import useFunctions from "@/use/functions1";


export default /*@__PURE__*/_defineComponent({
  __name: 'ApplicationResultCard',
  props: {
    application: {},
    pageName: {},
    layout: {}
  },
  emits: ["setSelectedApplication"],
  setup(__props: any, { emit: __emit }) {

const { decodeHTMLEncodedStr } = useFunctions();

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "xrow",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('setSelectedApplication', __props.application))),
    to: `/${__props.pageName.toLowerCase()}/${__props.application.referenceId}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(decodeHTMLEncodedStr)(__props.application.initials) || ""), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h4", {
                  title: __props.application.name,
                  innerHTML: _unref(decodeHTMLEncodedStr)(__props.application.name) || 'No Name'
                }, null, 8, _hoisted_8),
                (__props.layout === 'table')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h3", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(__props.application.createdAtFormatted), 1),
                          _cache[1] || (_cache[1] = _createTextVNode(" | ", -1)),
                          (__props.application.referenceIdSearchNotification)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "xcell xsearchtext",
                                innerHTML: __props.application.referenceIdSearchNotification
                              }, null, 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(__props.application.referenceId), 1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("h5", {
                class: "xlender",
                title: __props.application.lenderName || __props.application.defaultLenderName
              }, _toDisplayString(__props.application.lenderName || __props.application.defaultLenderName), 9, _hoisted_14),
              (__props.application.nameCoApplicant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon-people" }, null, -1)),
                    _cache[3] || (_cache[3] = _createTextVNode("  ", -1)),
                    _createElementVNode("span", {
                      class: "xcoapplicant xsearchtext xsmall-text",
                      innerHTML: __props.application.nameCoApplicant
                    }, null, 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              (__props.application.searchNotification)
                ? (_openBlock(), _createElementBlock("h6", {
                    key: 1,
                    class: "xsearch-notification",
                    innerHTML: __props.application.searchNotification
                  }, null, 8, _hoisted_17))
                : _createCommentVNode("", true),
              (__props.application.searchNotifications)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "xsearch-notifications",
                    innerHTML: __props.application.searchNotifications
                  }, null, 8, _hoisted_18))
                : _createCommentVNode("", true)
            ])
          ]),
          (__props.layout === 'boxes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h3", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(__props.application.createdAtFormatted), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(" | ", -1)),
                    (__props.application.referenceIdSearchNotification)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "xsearchtext",
                          innerHTML: __props.application.referenceIdSearchNotification
                        }, null, 8, _hoisted_22))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "xsearchtext",
                          innerHTML: __props.application.referenceId
                        }, null, 8, _hoisted_23))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(__props.application.statusName), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          (__props.layout === 'table')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(__props.application.statusName), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})